"use client"

import { useEffect, useState } from "react"
import { PlaneIcon as PaperAirplaneIcon, Send } from "lucide-react"

export default function InputForm( { runProcess, inputMsg, setInputMsg } ) {
  const [value, setValue] = useState('')
  
  const handleSubmit = (e) => {
    e.preventDefault()
    setInputMsg(value)
    runProcess(value);
  }

  useEffect(() => {
    setValue(inputMsg);
  }, [inputMsg])

  return (
    <div className="w-full">
      <form onSubmit={handleSubmit} className="relative">
        <input
          type="text"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="トヨタとTeslaの業績を分析して"
          className="w-full px-4 py-3 rounded-xl bg-white border border-gray-200 shadow-sm focus:outline-none focus:ring-1 focus:ring-emerald-300 focus:border-transparent pr-12"
        />
        <button
          type="submit"
          className="absolute right-1 top-1/2 -translate-y-1/2 p-2 w-10 h-10 rounded-xl flex items-center justify-center bg-gradient-to-r from-emerald-500 to-teal-400 shadow-lg"
        >
            <Send className="h-8 w-8 text-white" />
        </button>
      </form>
    </div>
  )
}

